export default __webpack_public_path__ + "static/media/askGamblers.22cfe91b.svg";